import React from "react";

const Stepper = ({ children, step }) => {
  return <>{children[step]}</>;
};

export default Stepper;
